import config from '../config';

export const trackPerkEvents = (planType, props) => {
  const { perkId, perkName } = props;
  if (planType === 'monthly') {
    return window.analytics.track(
      'Clicked Switched to Yearly',
      {
        perkId,
        perkName: perkName || `${config.company} plan change`,
      }
    );
  }
  return window.analytics.track(
    'Clicked Subscribe CTA',
    {
      ctaLocation: 'Premium Perks',
      perkId,
      perkName: perkName || `${config.company} go premium`,
      brand: config.company
    }
  );
};

export default trackPerkEvents;
